import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFortinetComponent } from './simple-icons-fortinet.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFortinetComponent ],
    exports:      [ SimpleIconsFortinetComponent ],
    bootstrap:    []
})
export class SimpleIconsFortinetModule {}
